// generated from 3_623 samples

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const workflowConversionEventFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("workflow_conversion_event_filter"),
  comparison_key: z.enum([
    "8", // 3_041 (83.94%)
    "7", // 582 (16.06%)
  ]),
  display_name: z.string(),
  // undefined: 617 (17.03%), defined 3_006 (82.97%)
  raw_value: common.objectId.optional(),
  value: z.object({
    // true 635 (17.53%), false 2_988 (82.47%)
    expired: z.boolean(),
    id: common.objectId,
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
